import axios from "axios";
import { _authHeader } from "../auth._header";
import helpers from "@/helpers/helper";

const API_URL = helpers.API_ENDPOINT;

class UserService {
    getUser(data) {
        return axios.get(API_URL + "users", { params: helpers.params(data), headers: _authHeader(), }).then((response) => {
            return response.data;
        });
    };
    getUserSelect(data) {
        return axios.get(API_URL + "users-select", {headers: _authHeader(), }).then((response) => {
            return response.data;
        });
    };
}

export default new UserService();